<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="sectionHeader">
        <div class="header">
          <div class="title">
              <div class="label">
                  {{'PAYMENT_VOUCHER.title' | translate}}
              </div>
              <div class="help">
                <!-- <app-help [helpData]="helpData" ></app-help> -->
              </div>
            </div>
            <div class="buttons" (click)="createPaymentVoucher();">
              <div class="button">
                {{'PAYMENT_VOUCHER.create_payment_voucher' | translate}}
              </div>
            </div>
        </div>
      </div>

      <div class="table">
          <table mat-table class="mat-elevation-z8" #table *ngIf="paymentVouchersList && paymentVouchersList.data.length;else noPaymentVouchers"  [dataSource]="paymentVouchersList">
              <ng-container matColumnDef="voucher_no">
                <th mat-header-cell *matHeaderCellDef> {{'PAYMENT_VOUCHER.voucher_no' | translate}}</th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon class="icons">attach_file</mat-icon>
                  {{ element.voucher_no }}
                </td>
              </ng-container>
              <ng-container matColumnDef="date_of_payment">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'PAYMENT_VOUCHER.date_of_payment' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.date_of_payment }}
                  </td>
              </ng-container>
              <ng-container matColumnDef="creation_date">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'PAYMENT_VOUCHER.creation_date' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                      {{ element.creation_date }}
                  </td>
              </ng-container>
              <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'PAYMENT_VOUCHER.type' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.type }}
                  </td>
              </ng-container>
              <ng-container matColumnDef="payee">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'PAYMENT_VOUCHER.payee' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.payee }}
                  </td>
              </ng-container>
              <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'PAYMENT_VOUCHER.amount' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.amount }}
                  </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'PAYMENT_VOUCHER.action' | translate}}</th>
                <td mat-cell *matCellDef="let element">
                  <div class="submit" (click)="$event.stopPropagation();openUploadDialog(element)">
                    <div class="button">
                      {{'PAYMENT_VOUCHER.uploadDocs' | translate}}
                    </div>
                  </div>
                </td>
            </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayColumns;" style="font-weight: bold !important;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="getOneVoucher(row)"></tr>
            </table>
            <mat-paginator [length]="(paymentVouchersList) ? totalVouchers : 0" [pageSize]="25" [pageSizeOptions]="[5,10, 25, 50, 100]" showFirstLastButtons
            (page)="pageNavigate($event)" style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"></mat-paginator>
      </div><ng-template #uploadDialog>
        <div class="dialogMain">
          <div class="section">
            <div class="header">
              <div class="label">
                {{'PAYMENT_VOUCHER.uploadDocs' | translate}}<i class="material-icons" (click)="uploadDocsRef.close();">clear</i>
              </div>
            </div>
            <div class="uploadFile">
              <input class="inputField" multiple (change)="fileChanged($event)" type="file">
            </div>
            <div class="submitButton" style="float: right;">
              <div class="button"   (click)="uploadDocs();">
                {{'PAYMENT_VOUCHER.submit' | translate}}
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #noPaymentVouchers>
          <div class="no-payment-vouchers">
              {{'PAYMENT_VOUCHER.no_payment_voucher_found' | translate}}
      </div>
      </ng-template>

    </div>
  </div>

